import classNames from "classnames";
import React from "react";
import { cn } from "~/utils/fontsConfig";

type FontProps = {
    children: React.ReactNode;
    className?: React.ComponentProps<"div">["className"];
    renderLinks?: boolean;
    onClick?: () => void;
    href?: string;
};

// Component definitions
const H1 = (props: FontProps) => (
    <h1
        className={cn(
            `
      font-faktum
      text-4xl
      font-[200] 
      leading-10
    `,
            props.className,
        )}
    >
        {props.children}
    </h1>
);

const H2 = (props: FontProps) => (
    <h1
        className={classNames(
            `
      font-ibm-plex-mono
      text-[24px]
      font-[500] 
      leading-relaxed
    `,
            props.className,
        )}
    >
        {props.children}
    </h1>
);

const H3 = (props: FontProps) => (
    <h1
        className={classNames(
            `
            font-ibm-plex-mono
            text-[16px]
            leading-relaxed
    `,
            props.className,
        )}
    >
        {props.children}
    </h1>
);

const P1 = (props: FontProps) => (
    <p
        className={classNames(
            "font-ibm-plex-mono text-[16px] font-[300] leading-normal",
            props.className,
        )}
    >
        {props.children}
    </p>
);

const P2 = (props: FontProps) => (
    <p
        className={classNames(
            "font-space-mono text-[12px] font-[400] leading-normal",
            props.className,
        )}
    >
        {props.children}
    </p>
);

const P3 = (props: FontProps) => (
    <p
        className={classNames(
            "font-space-mono text-[8px] font-[400] leading-normal",
            props.className,
        )}
    >
        {props.children}
    </p>
);

const Tag = (props: FontProps) => (
    <span
        className={classNames(
            `
      font-ibm-plex-mono
      text-[14px]
      font-[400]
      uppercase
      leading-snug

    `,
            props.className,
        )}
        onClick={props.onClick}
    >
        {props.children}
    </span>
);

const Body = (props: FontProps) => {
    if (props.renderLinks) {
        return (
            <span
                dangerouslySetInnerHTML={{ __html: props.children as string }}
                className="linkify font-ibm-plex-mono text-[16px] leading-snug"
            />
        );
    }

    return (
        <span className="font-ibm-plex-mono text-[16px] leading-snug">
            {props.children}
        </span>
    );
};

export const BlueTag = (props: FontProps) => {
    return (
        <span
            className={cn(
                "ml-2 mr-2 inline-flex min-h-[24px] min-w-[50px] items-center justify-center gap-2.5 rounded bg-v3-O500 bg-opacity-25 px-2 py-1 text-xs font-medium leading-4 tracking-wider text-v3-O100",
                props.className,
            )}
        >
            {props.children}
        </span>
    );
};

export { Body, H1, H2, H3, P1, P2, P3, Tag };
